import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../redux/store';
import { toastAdapter } from './slice';

const toastState = (state: RootState) => state.toast;
const { selectAll } = toastAdapter.getSelectors();

const selectAllToasts = createSelector(toastState, selectAll);

export default selectAllToasts;
